import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5088c918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "token-list-table" }
const _hoisted_4 = { class: "td-content relative" }
const _hoisted_5 = { class: "flex align-items-center" }
const _hoisted_6 = { class: "td-content" }
const _hoisted_7 = { class: "td-content" }
const _hoisted_8 = { class: "td-content flex-column align-items-start" }
const _hoisted_9 = { class: "td-content" }

import AddTokenButton from '@/components/token/AddTokenButton.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { Portfolio, TokenInfo } from '@/sdk/entities/portfolio';
import { format } from '@/utils/format';
import { addToken, TokenOptions } from '@/utils/blockchain';
import TokenChainAvailable from '@/views/pages/liquidity/portfolios/portfolio/portfolioCompound/portfolioToken/TokenChainAvailable.vue';
import { PortfolioSource } from '@/sdk/entities/PortfolioSource';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useEVMWallet } from '@/store/modules/wallet/useEVMWallet';
import roundMixin from '@/mixins/round.mixin';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { computed, watch } from 'vue';
import { getPortfolioTokensWithFirstBaseToken } from '@/helpers/portfolio.helper';
import { PORTFOLIO_LOGGER } from '@/utils/debug/portfolio.logger';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioTokenList',
  props: {
    portfolio: null
  },
  setup(__props: any) {

const props = __props as {
  portfolio: Portfolio;
}



const { state } = useStore();
const { walletState } = useEVMWallet();
const { t } = useI18n();
const { mathMixRound } = roundMixin.methods;

const isBaseToken = (token: TokenInfo) => {
  return props.portfolio.baseToken.unwrapWETH().symbol === token.token.unwrapWETH().symbol;
};

const tableData = computed(() => getPortfolioTokensWithFirstBaseToken(props.portfolio));

const isNotAvailableToken = (token: TokenInfo) => {
  return props.portfolio.type === PortfolioSource.PORTFOLIO_CROSSCHAIN
    ? !token.isPresentLocally
    : false;
};
const tokenRowClass = data => {
  return [isNotAvailableToken(data) ? 'not-available' : ''];
};

const tokenShare = (token: TokenInfo) => {
  return mathMixRound(
    token.getPortfolioSharePercent(props.portfolio.portfolioTotalValueBase),
    0,
    4,
  );
};
const tokenTarget = (token: TokenInfo) => {
  return mathMixRound(token.targetWeight.multipliedBy(100), 0);
};

const addToWallet = token => {
  const tokenParams: TokenOptions = {
    address: token.tokenAddress,
    symbol: token.token.symbol,
    decimals: token.token.decimals,
    image: token.token.tokenIconUrl,
  };
  addToken(tokenParams);
};

watch(
  () => props.portfolio,
  portfolio => {
    PORTFOLIO_LOGGER.logging(portfolio);
  },
  {
    immediate: true,
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('portfolio.tokens.caption')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        "row-class": tokenRowClass,
        value: _unref(tableData),
        tableStyle: "min-width: 30rem",
        scrollable: "",
        expandedRows: _unref(tableData),
        "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tableData) ? (tableData).value = $event : null))
      }, {
        expansion: _withCtx((slotProps) => [
          (isNotAvailableToken(slotProps.data) && _unref(state).layout.isMobile)
            ? (_openBlock(), _createBlock(TokenChainAvailable, {
                key: 0,
                "chain-list": slotProps.data.availableOn,
                class: "text-left ml-s2 text-muted mb-s1",
                "as-line": ""
              }, null, 8, ["chain-list"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            header: "",
            frozen: "",
            style: {"min-width":"7rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(TokenIcon, {
                      "icon-src": slotProps.data.token.tokenIconUrl,
                      symbol: slotProps.data.token.unwrapWETH().symbol,
                      full: "",
                      size: _unref(state).layout.isMobile ? '20' : '24'
                    }, null, 8, ["icon-src", "symbol", "size"]),
                    (isBaseToken(slotProps.data))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["label-light text-xs white-space-nowrap", 
                      _unref(state).layout.isMobile ? 'label-panel label_t-l py-s1  min-h-0' : 'ml-s2'
                    ])
                        }, _toDisplayString(_unref(t)('baseToken')), 3))
                      : _createCommentVNode("", true)
                  ]),
                  (isNotAvailableToken(slotProps.data) && !_unref(state).layout.isMobile)
                    ? (_openBlock(), _createBlock(TokenChainAvailable, {
                        key: 0,
                        "chain-list": slotProps.data.availableOn,
                        class: "text-left mt-s1"
                      }, null, 8, ["chain-list"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: _unref(t)('portfolio.tokens.amount')
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)((slotProps.data as TokenInfo).amount.toExact())), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            header: _unref(t)('portfolio.tokens.price')
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_7, " $" + _toDisplayString(_unref(format)(
                  __props.portfolio.getValueInUSD(
                    (slotProps.data as TokenInfo).getPriceRelative().toString(),
                  ),
                )), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            header: _unref(t)('portfolio.tokens.percentage.caption')
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('portfolio.tokens.percentage.share', { value: tokenShare(slotProps.data) })), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(t)('portfolio.tokens.percentage.target', { value: tokenTarget(slotProps.data) })), 1)
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            header: "",
            style: {"max-width":"10rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_9, [
                (
                  slotProps.data &&
                  !isNotAvailableToken(slotProps.data) &&
                  !slotProps.data.token.isWETHToken() &&
                  _unref(walletState).connector?.id === 'injected'
                )
                  ? (_openBlock(), _createBlock(AddTokenButton, {
                      key: 0,
                      onClick: ($event: any) => (addToWallet(slotProps.data)),
                      full: "",
                      class: "ml-auto"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "expandedRows"])
    ])
  ]))
}
}

})